// tslint:disable
export const environment = {
  production: true,
  hmr: false,
  analyticsId: 'UA-124201022-2',
  name: 'production',
  release: 'v1.0.983',
  url: 'https://coara.co',
};
